import { render } from "./AddQuery.vue?vue&type=template&id=303400aa&scoped=true"
import script from "./AddQuery.vue?vue&type=script&lang=js"
export * from "./AddQuery.vue?vue&type=script&lang=js"

import "./AddQuery.vue?vue&type=style&index=0&id=303400aa&scoped=true&lang=css"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-303400aa"]])

export default __exports__